import type { Column } from "./Table";

/**
 * Resolves the inline style for a column's <th>/<td>. When `capMaxWidth`
 * is true (the cell body case), forces `maxWidth` so long content is
 * truncated. When the column opts into `hug`, use the 1px + nowrap trick
 * so the column shrinks to its own content instead of absorbing extra
 * horizontal space in a `table { width: 100% }` layout.
 */
export function columnSizingStyle(col: Column<unknown>, capMaxWidth: boolean) {
  if (col.width)
    return capMaxWidth
      ? { width: col.width, maxWidth: col.width }
      : { width: col.width };
  if (col.hug) return { width: "1px", whiteSpace: "nowrap" as const };
  return undefined;
}
